<template>
  <div class="online-studyEvaluate online-answerResult">
    <div class="train-Switch-box">
      <div class="train-Switch">
        <div class="switch-left">
          <div class="tabs">
            <span class="color-333">{{$t('Evaluation.answerResult')}}</span>
          </div>
        </div>
        <div class="switch-right" v-if="getScoreData.examine_score!=100">
          <div tag="div" class="record btnShadow bg-base cursor" @click="wrongQuetion">{{ $store.state.currentChild.class_genre == 'school'?$t('Evaluation.analysis'):$t('Evaluation.explain') }}</div>
        </div>
      </div>
    </div>
    <div class="result-baby">
      <div class="img">
        <img src="@/assets/images/studyCenter/Evaluation/child.png" alt />
      </div>
      <div class="childInfo bg-base1">
        <span class="color-white">{{studentInfo.student_cnname}}</span>
        <!-- <span class="color-white">2019-10-16</span> -->
      </div>
      <p class="countine" v-html="getScoreData.examine_score==100?$t('Evaluation.good'):$t('Evaluation.ComeOn')"></p>
    </div>
    <div class="subject-change">
      <span class="prev btn cur cursor" @click="prevQuetion">{{$store.state.globalTxt.examin8?$store.state.globalTxt.examin8:$t('Evaluation.goBack')}}</span>
      <!-- {{getScoreData.examine_score}} -->
      <span
        class="next btn cur cursor"
        v-if="getScoreData.examine_score<100 && getScoreData.examine_score>70"
        @click="nextQuetion(1)"
      >{{$t('Evaluation.wrongQuestion')}}</span>
      <span
        class="next btn cur cursor"
        v-else-if="getScoreData.examine_score<=70"
        @click="nextQuetion(0)"
      >{{$t('Evaluation.againTest')}}</span>
    </div>
    <!-- 恭喜获得奖励的弹窗 -->
    <pop-tips
      @handConfirm="handConfirm"
      @handleCloseTip="handleCloseTip"
      :dialogVisable="dialogVisable"
      :popTipsCont="popTipsCont"
    ></pop-tips>
  </div>
</template>

<script>
import evaluationStore from "@/views/StudyCenter/Evaluation/Evaluation";
import PopTips from "@/components/popTips";
export default {
  name: "answerResult",
  components: {
    PopTips
  },
  data() {
    return {
      studentInfo: {
        token: "",
        member_id: "",
        student_id: "", //学生ID
        student_cnname: "", //孩子的姓名
        examine_branch: "", //检测编号
        examine_name: "" //检测名称
      },
      getScoreData: {}, //考试成功信息
      dialogVisable: false,
      popTipsCont: {
        title: this.$t('Evaluation.getMonery'),
        context: `<span class="gold"></span> `,
        btns: [
          {
            text: this.$t('Common.confirm'),
            event: "handConfirm"
          }
        ]
      }
    };
  },
  mounted() {},
  updated() {},
  created() {
    this.studentInfo.student_cnname = this.$store.state.currentChild.student_cnname;
    this.studentInfo.examine_name = unescape(this.$route.query.examine_name);
    this.studentInfo.examine_branch = this.$route.query.examine_branch; //检测编号
    this.getScoreData = this.$store.state.getCodeInfo;
    if(this.$route.query.isSource == 1){
      if (this.getScoreData !='') {
         let childInfo = this.$store.state.currentChild;
        // console.log(typeof this.getScoreData.examine_score);
        if (this.getScoreData.examine_playprice) {
          if(this.$route.query.from == 'task'){//从作业任务的检测任务 过来
            if(this.$Tool.getStorage("setTask")==0 && this.getScoreData.examine_score>70){
              this.SubmitTask();
            }else{
              this.dialogVisable = false;
            }
          }else{
            if (this.getScoreData.examine_type == 0) {
              //金币
              this.popTipsCont.context = `<span class="gold"></span> +${this.getScoreData.examine_playprice}`;
              childInfo.student_goldprice = this.getScoreData.totalPrice;
            } else if (this.getScoreData.examine_type == 1) {
              //钻石
              this.popTipsCont.context = `<span class="diamond"></span> +${this.getScoreData.examine_playprice}`;
              childInfo.student_diamondprice = this.getScoreData.totalPrice;
            }
            this.dialogVisable = true;
          }
          
          this.$Tool.setStorage("currentStuInfo", childInfo); //当前学生的个人信息
          this.$store.dispatch("setCurrentChild", childInfo);
        }
      }
      console.log(this.getScoreData);
    }
  },
  watch: {},
  computed: {},
  methods: {
    //完成
    prevQuetion() {
      this.$router.push({
        path: "/studyEvaluate/evaluationList"
      });
      let allTime = this.$Tool.getStorage("allTime");
      console.log(allTime)
      this.$Tool.setStorage("remainTime", allTime); //考试时间
      this.$store.dispatch("setRemainTime", allTime);
    },
    //再考一次
    nextQuetion(index) {
      console.log(
        this.studentInfo.examine_branch,
        this.studentInfo.examine_name
      );
      // this.$Tool.setStorage("remainTime", 1); //考试时间
      // this.$store.dispatch("setRemainTime", 1);
      if(index == 0){
        let allTime = this.$Tool.getStorage("allTime");
        console.log(allTime)
        this.$Tool.setStorage("remainTime", allTime); //考试时间
        this.$store.dispatch("setRemainTime", allTime);
      }
      this.$router.push({
        path: "/subject",
        query: {
          examine_branch: this.studentInfo.examine_branch,
          examine_name: escape(this.studentInfo.examine_name),
          examAgain: index, //是否是再考一次
          myIsErroy: 1 //我是错题 - 提交标识
        }
      });
    },
    submitOk() {
      this.dialogVisable = true;
    },
    handleCloseTip() {
      this.dialogVisable = false;
    },
    handConfirm() {
      console.log("ok");
      this.dialogVisable = false;
      //  this.$Tool.setStorage("getCodeInfo", '');
      // this.$store.dispatch("setgetCodeInfo", '');
      // this.$Tool.removeStorage("getCodeInfo");
      // let childInfo = this.$store.state.currentChild;
      // if (this.getScoreData.examine_type == 0) {
      //     //金币
      //     childInfo.student_goldprice = this.getScoreData.totalPrice;
      //   } else if (this.getScoreData.examine_type == 1) {
      //     //钻石
      //     childInfo.student_diamondprice = this.getScoreData.totalPrice;
      //   }
      // this.$Tool.setStorage("currentStuInfo", childInfo); //当前学生的个人信息
      // this.$store.dispatch("setCurrentChild", childInfo);
    },
    //错题分析
    wrongQuetion() {
      this.$router.push({
        path: "/studyEvaluate/wrongAnalysis",
        query: {
          examine_branch: this.studentInfo.examine_branch,
          examine_name: escape(this.studentInfo.examine_name),
          examAgain: 1, //是否 是本题结束的 错题分析
          mySourceErroy:this.$route.query.mySourceErroy?this.$route.query.mySourceErroy:0,//错题练习 - 标识(和单园练习同页面的这个)
        }
      });
    },
    // 完成 题目 提交成功
    SubmitTask() {
      evaluationStore.SubmitTask({
        member_id: this.$store.state.member_id,
        token: this.$store.state.token,
        student_id: this.$store.state.currentChild.student_id,
        taskitem_id: this.$route.query.taskitem_id // 	任务id 仅在任务完成部分的复习模块中需要传
      }).then(res => {
        const { error,result } = res.data;
        if (error == 0) {
          const { list } = result;
          if (list.playclass == 0) {//奖励类型0金币奖励1钻石奖励
            this.popTipsCont.context = `<span class="gold"></span> +${result.list.playprice}`;
            let childInfo = this.$store.state.currentChild;
            childInfo.student_goldprice = list.totalPrice;
            this.$Tool.setStorage("currentStuInfo", childInfo);
            this.$store.dispatch("setCurrentChild", childInfo);
          } else if(list.playclass == 1) {
            this.popTipsCont.context = `<span class="diamond"></span> +${result.list.playprice}`;
            if(result.list.playprice==0){
              this.popTipsCont.context = `<span class="diamond"></span> +1`;
            }else{
              this.popTipsCont.context = `<span class="diamond"></span> +${result.list.playprice}`;
            }
            let childInfo = this.$store.state.currentChild;
            childInfo.student_diamondprice = list.totalPrice;
            this.$Tool.setStorage("currentStuInfo", childInfo);
            this.$store.dispatch("setCurrentChild", childInfo);
          }
          this.dialogVisable = true;
          this.$Tool.removeStorage("setTask");
        }
      });
    },
  },
  beforeDestroy(){
    console.log('离开当前页面')
    this.$Tool.removeStorage("setTask");
  }
};
</script>

<style lang="less">
.online-answerResult {
  .Poplayer-box {
    .close {
      display: none;
    }
  }
  .result-baby {
    text-align: center;
    margin-top: 40px;
    .img {
      img {
      }
    }
    .childInfo {
      width: 230px;
      text-align: center;
      border-radius: 10px;
      padding: 20px 0;
      margin: -10px auto 20px;
      span {
        display: block;
        font-size: 16px;
        &:first-child {
        }
      }
    }
    .countine {
    }
  }
  .prop-content {
    display: flex;
    align-items: center;
    justify-content: center;
    .gold {
      width: 26px;
      height: 26px;
      margin-right: 10px;
      background-color: red;
      border-radius: 50%;
      background: url(../../../../assets/images/studyCenter/questions/gold-icon.png)
        center center no-repeat;
      background-size: cover;
    }
    .diamond {
      width: 26px;
      height: 26px;
      margin-right: 10px;
      background-color: red;
      border-radius: 50%;
      background: url(../../../../assets/images/myCenter/diamond.png) center
        center no-repeat;
      background-size: cover;
    }
  }
}
</style>
